import type { ApiShortcutJSON } from 'mastodon/api_types/shortcuts';
import { me } from 'mastodon/initial_state';

// Shared by the compact sidebar panel and the full /shortcuts list -- the
// route a shortcut opens, and the label to show for it.

export const getShortcutPath = (
  shortcut: ApiShortcutJSON,
): string | undefined => {
  if (shortcut.target_type === 'account' && shortcut.account) {
    return `/@${shortcut.account.acct}`;
  }
  if (shortcut.target_type === 'group' && shortcut.group) {
    return `/group/${shortcut.group.id}`;
  }
  if (shortcut.target_type === 'chat_room' && shortcut.chat_room) {
    return `/chat/${shortcut.chat_room.id}`;
  }
  return undefined;
};

export const getShortcutTitle = (
  shortcut: ApiShortcutJSON,
): string | undefined => {
  if (shortcut.target_type === 'account' && shortcut.account) {
    return shortcut.account.display_name || shortcut.account.username;
  }
  if (shortcut.target_type === 'group' && shortcut.group) {
    return shortcut.group.display_name;
  }
  if (shortcut.target_type === 'chat_room' && shortcut.chat_room) {
    const room = shortcut.chat_room;
    if (room.name) {
      return room.name;
    }
    const others = room.accounts.filter((account) => account.id !== me);
    return (others.length > 0 ? others : room.accounts)
      .map((account) => account.display_name || account.username)
      .join(', ');
  }
  return undefined;
};
